// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"50381b03","319":"bc78476f","635":"25d9b2ce","787":"948fcc8c","805":"7f684ce2"}[chunkId] + ".chunk.js";
};